import { PkIdentifier } from '@uefadigital/panenka-react';

import FormGuideAvatar from '../../../FormGuideAvatar';
import { useWindowSize } from '../../../hooks/useWindowSize';
import { useTranslateFn } from '../../../Translate';

import { hydrateWithTranslations } from '@services/TranslatorService';
import type { FormGuideOutcome } from '@shared-types/form-guide.types';
import type { Match, Team } from '@shared-types/match.types';
import { dateToString } from '@utilities/dateTime';

import * as classes from '../styles.module.scss';

export const FormGuideMatchExtended = ({
  match,
  outcome,
  team,
}: {
  match: Match;
  outcome: FormGuideOutcome;
  team: Team;
}) => {
  const { isDesktopSmall } = useWindowSize();
  const t = useTranslateFn();

  return (
    <PkIdentifier className='pk-py--xs2'>
      <FormGuideAvatar
        slot='prefix'
        outcome={outcome}
        match={match}
        teamId={team.id}
        textClassName={classes.resultText}
      />
      <div slot='primary'>
        {isDesktopSmall && `${t('history_h2h_versus')} `}
        {(!isDesktopSmall || (isDesktopSmall && match.homeTeam.id !== team.id)) &&
          hydrateWithTranslations(match.homeTeam).displayTeamCode}
        {!isDesktopSmall && ` ${match.score.total.home}-${match.score.total.away} `}
        {(!isDesktopSmall || (isDesktopSmall && match.awayTeam.id !== team.id)) &&
          hydrateWithTranslations(match.awayTeam).displayTeamCode}
      </div>
      {isDesktopSmall ? (
        <div slot='secondary'>
          {match.score.total.home}-{match.score.total.away}
        </div>
      ) : (
        <div slot='secondary'>{dateToString(match.kickOffTime.dateTime, 'ddd D MMM')}</div>
      )}
    </PkIdentifier>
  );
};
